module.exports = __webpack_public_path__ + "img/list-questions.8f7b2d6d.svg";